import { Filter } from '~/mappers/itemListing/models';

export const getFilterValuesFromQueryString = (
  filters: Filter[],
  activeFilterUids: string[]
) =>
  filters
    .flatMap((filter) =>
      filter.options.map(({ categoryRef }) => ({
        group: filter.label,
        value: categoryRef,
      }))
    )
    .filter(({ value: { uid } }) => activeFilterUids.includes(uid));
